import { trackEvent, INPUT_KEYS, DIMENSION, EVENT } from '@cube/track';

export function trackContentLoad({ context, id, title, provider, vendor, type }) {
	trackEvent(context, {
		[INPUT_KEYS.action]: EVENT.contentload,
		[DIMENSION.contentid]: id,
		[DIMENSION.contenttitle]: title,
		[DIMENSION.contentprovider]: provider,
		[DIMENSION.contentvendor]: vendor,
		[DIMENSION.contenttype]: type
	});
}

export function trackPageLoad(context) {
	trackEvent(context, {
		[INPUT_KEYS.action]: EVENT.pageload
	});
}
